import { DependencyList, EffectCallback } from 'react';
import { useIsMounted } from './useIsMounted';
import { useEffectDeepCompare } from './useEffectDeepCompare';

/**
 * Customized effect hook that does is not executed on the first render.
 * @param effect The effect callback.
 * @param deps The effect dependencies.
 */
export const useUpdateEffectDeepCompare = (effect: EffectCallback, deps?: DependencyList) => {
  const isMounted = useIsMounted();

  useEffectDeepCompare(() => {
    if (isMounted()) {
      return effect();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
